import React, { useState, useEffect } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";
import { reqGET } from "../../Utils";
import Hosts from "../../Hosts";
import { getTokenInfo } from "../../UseToken";
import { language } from '../WEBContent/Language';

const GraficoAdmin = (lang) => {
  const [departamentosGraficos, setDepartamentosGraficos] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [data, setData] = useState([]);
  //const [colors,setColors]=useState([]);
  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const response = await reqGET(`${Hosts.SIMCore_API}/tarefa/${getTokenInfo().companycode}`);
        if (!response || !response.data) {
          throw new Error("Resposta inválida da API de tarefas");
        }
        setTasks(response.data);
      } catch (error) {
        console.error("Erro ao buscar as tarefas:", error);
      }
    };

    const fetchDepartamentos = async () => {
      try {
        const res = await reqGET(`${Hosts.SIMCore_API}/intranet/departments/${getTokenInfo().companycode}`);
        if (!res || !res.data) {
          throw new Error("Resposta inválida da API de departamentos");
        }
       // console.log("Grafico dos departamentos cores",res.data)

        const departamentoOptions = res.data.map(departamento => ({
          id: departamento.id,
          name: departamento.info.name,
          color:departamento.info.color.primary

        }));

        //setColors(departamentoOptions.color)
        setDepartamentosGraficos(departamentoOptions);
        console.log("Cores dos departamentos",departamentosGraficos)
      } catch (error) {
        console.error("Erro ao buscar os departamentos:", error);
      }
    };

    fetchDepartamentos();
    fetchTasks();
  }, []);

  useEffect(() => {
    if (departamentosGraficos.length === 0 || tasks.length === 0) return;

    const contagemTarefas = {};

    tasks.forEach(task => {
      const departamentoNome = task.info?.departamento;
      if (!departamentoNome) return;

      if (!contagemTarefas[departamentoNome]) {
        contagemTarefas[departamentoNome] = { total: 0 };
      }

      const estado = task.info.estado.labelPt;
      if (estado !== "Concluído") {
        contagemTarefas[departamentoNome].total += 1;
        contagemTarefas[departamentoNome][estado] = (contagemTarefas[departamentoNome][estado] || 0) + 1;
      }
    });

    const dataFormatada = departamentosGraficos.map(departamento => ({
      name: departamento.name,
      color:departamento.color,
      quantidade: contagemTarefas[departamento.name]?.total || 0,
      estados: contagemTarefas[departamento.name] || {}
    }));

    setData(dataFormatada);
  }, [departamentosGraficos, tasks]);
  //console.log("ver se ja aparecem as cores para o grafico",data)
  //const colors = ["#8884d8", "#82ca9d", "#ffc658", "#ff7300", "#0088fe", "#d0ed57", "#a4de6c"];
  //const colors =  data.color;
  
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const departamentoNome = payload[0].payload.name;
      const estados = payload[0].payload.estados;
      return (
        <div style={{ background: "#fff", padding: 10, borderRadius: 5, boxShadow: "0px 0px 5px rgba(0,0,0,0.2)" }}>
          <p><strong>{departamentoNome}</strong></p>
          {Object.keys(estados).length > 1 ? (
            <ul>
              {Object.entries(estados).map(([estado, quantidade]) =>
                estado !== "total" ? <li key={estado}>{estado}: {quantidade}</li> : null
              )}
            </ul>
          ) : (
            <p>Sem tarefas pendentes</p>
          )}
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <XAxis dataKey="name" />
        <YAxis allowDecimals={false} /> 
        <YAxis />
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="quantidade">
          {data.map((departamento, index) => (
            <Cell key={`cell-${index}`} fill={departamento.color} />
            
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default GraficoAdmin;